/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';
	const $map = location.pathname.split('/');

	// <ニュース一覧>
	const newsYearList = () => {
		if($('.js-news-yearList').length) {
			const latestYear = $('.rt_bn_latest_news .rt_latest_year').text();
			let earliestYear = $('.rt_bn_earliest_news .rt_earliest_year').text();
			const directoryYear = $map[$map.length -2];

			// 一番古い年が一番早い年-5年より新しい場合
			if(earliestYear < latestYear - 5) {
				earliestYear = latestYear - 5;
			}
		
			// optionを追加
			for(var i =latestYear; i>=earliestYear; i--) {
				$('.js-news-yearList').append($('<option>').html(''+i+'').val(''+i+''));
			}
			// 見ている年をselected
			$('.js-news-yearList').val(directoryYear);

			// 選択した年に飛ばす
			$('.js-news-yearList').change(function(){
				location.href = location.pathname.replace(directoryYear, $(this).val());
			});
		}
	};

	// <ニュース一覧>カレント
	const newsCurrent = () => {
		if($('.mod-tab').length) {
			const currentCat = $map[$map.length -3];
			$('.mod-tab li').each((idx,ele) => {
				let thisHref = $(ele).find('a').attr('href').split('/').filter(Boolean);
				let thisCat = thisHref[thisHref.length -1];
				if(thisCat === currentCat) {
					$(ele).addClass(a);
				}
			});
			
		}
	};

	// <トップページ><ニュース一覧>pdfアイコン
	const pdfIcon = () => {
		if($('.js-newsLink-icon').length) {
			$('.js-newsLink-icon').each((idx,ele) => {
				if($(ele).attr('href').split('.')[1] === 'pdf') {
					$(ele).append('<svg class="icon ml10"><use xlink:href="/common/svg/sprite.svg#pdf" /></svg>');
				}
			});
		}
	}

	// <ニュース一覧>
	const newsListMore = () => {
		const $newsList = $('.js-newsList li');
		if($newsList.length) {
			let startCnt = 0, endCnt = 10;
			const addResult = () => {
				for(let i=startCnt; i<endCnt; i++) {
					if($newsList.eq(i).length) {
						$newsList.eq(i).addClass(v);
					} else {
						$('.js-newsList-more').remove();
						break;
					}
				}
			};
			// 最初の10件表示
			addResult();
			if($newsList.length <= 10) { $('.js-newsList-more').remove(); }
			// moreボタン押下で10件ずつ追加表示
			$('.js-newsList-more').on('click', () => {
				startCnt += 5; endCnt += 5;
				addResult();
			});
		}
	};


	newsYearList();
	newsCurrent();
	pdfIcon();
	newsListMore();

})(window.jQuery, window.FUNCTIONS);
